<template>
  <div>
    <div class="card-body form-gorup-last">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <p class="control-label">Username</p>
            <input v-model="stateUsername" v-validate="'required'" name="username" type="text" class="form-control" />

            <help-block field="username"/>
          </div><!-- /.form-group -->
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <p class="control-label">First Name</p>
            <input v-model="stateFirstName" v-validate="'required'" name="first_name" data-vv-as="first name" type="text" class="form-control" />

            <help-block field="first_name"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <p class="control-label">Last Name</p>
            <input v-model="stateLastName" v-validate="'required'" name="last_name" data-vv-as="last name" type="text" class="form-control" />

            <help-block field="last_name"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label">Phone</label>
            <input v-model="statePhone" v-validate="" name="phone" type="text" class="form-control" />
          </div><!-- /.form-group -->
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label">Agency</label>
            <multiselect
              @input="handleSelectAgencyCallback"
              :options="agencies"
              :value="agencySelected"
              :searchable="true"
              label="name"
              track-by="id"
              placeholder=""
              name="agency_id"
              v-validate=""
              data-vv-as="agency"
              :class="[errorClass('agency_id'), validClass('agency_id')]"
              :show-labels="false"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12">
          <div class="form-group">
            <p class="control-label">Backup Email Address</p>
            <input v-model="stateEmail" v-validate="'required|email'" name="email" type="email" class="form-control" />

            <help-block field="email"/>
          </div><!-- /.form-group -->
        </div>

        <div class="col-12 text-right">
          <div class="form-group">
            <ladda-button :click="handleSaveChanges" :validate="true" class="btn btn-success">Save Changes</ladda-button>
          </div><!-- /.form-group -->
        </div>
      </div><!-- /.row -->
    </div>
  </div>
</template>
<script>
import { userComputed, userMethods, agencyComputed, agencyMethods } from 'vx/helpers'
import { stateMapper } from 'mixins/users'
import { pick } from 'lodash'
import { handleServerErrors } from 'utils'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [stateMapper],

  components: {
    Multiselect
  },

  computed: {
    ...userComputed,
    ...agencyComputed
  },

  data () {
    return {
      agencySelected: null
    }
  },

  async created () {
    await this.getAgencies({ 'enabled': 'true' })
    this.agencySelected = this.user.agency
  },

  methods: {
    ...userMethods,
    ...agencyMethods,

    /**
     * Save changes to account
     */
    async handleSaveChanges () {
      let payload = pick(this.user, [
        'username',
        'first_name',
        'last_name',
        'phone',
        'email',
        'agency_id'
      ])

      try {
        await this.updateAccount(payload)
        this.$noty.success('Account details updated.')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    },

    handleSelectAgencyCallback (agency) {
      this.agencySelected = agency

      this.stateAgency = agency
        ? agency.id
        : null
    }
  }
}
</script>
